// extracted by mini-css-extract-plugin
module.exports = {"center":"PermissionDenied_center__2TAPn","errorCode":"PermissionDenied_errorCode__2Q4VG","errorDesc":"PermissionDenied_errorDesc__2RD85"};